

export enum KalturaPrivacyType {
    all=1,
	authenticatedUsers=2,
	membersOnly=3
}